import { render } from "./LoaderSpin.vue?vue&type=template&id=cedcd912&scoped=true"
import script from "./LoaderSpin.vue?vue&type=script&lang=js"
export * from "./LoaderSpin.vue?vue&type=script&lang=js"

import "./LoaderSpin.vue?vue&type=style&index=0&id=cedcd912&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cedcd912"]])

export default __exports__